import { NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectiveModule } from '../../directives/directives.module'
import { PipeModule } from '../../pipe/pipe.module';
import {MaterialModule} from '../obs.core/material.module';
import {WbpHeaderComponent} from './header/wbpHeader/wbpHeader.component';
import {WbpHeaderPubSplanComponent} from './header/wbpHeader/wbpHeaderOeffentlicheSpeiseplaene/wbpHeaderPubSplan.component';
import {WbpFooterComponent} from './footer/wbpFooter/wbpFooter.component';
import {WbaHeaderComponent} from './header/wbaHeader/wbaHeader.component';
import {WbaFooterComponent} from './footer/wbaFooter/wbaFooter.component';
import {SharedModule} from '../obs.shared/shared.module';
import {BarrierefreiheitModule} from '../obs.barrierefreiheit/barrierefreiheit.module';

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule,
    FormsModule,
    PipeModule,
    DirectiveModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    BarrierefreiheitModule,
  ],
  declarations: [
    WbpHeaderComponent,
    WbpHeaderPubSplanComponent,
    WbpFooterComponent,
    WbaHeaderComponent,
    WbaFooterComponent,
  ],
  exports: [
    WbpHeaderComponent,
    WbpHeaderPubSplanComponent,
    WbpFooterComponent,
    WbaHeaderComponent,
    WbaFooterComponent,
  ],
  providers: [
  ]
})
export class ShellModule { }
